import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    useMediaQuery,
    useTheme,
    IconButton,
    Box,
    Divider,
    Typography,
  } from "@mui/material";
  import CloseIcon from "@mui/icons-material/Close";

export default function AcceptConfirmationPopup({selectedId,open,onClose,title,component, maxWidth, showDivider,textBody,handleUpdateStatus}) {
   const handleClose=()=>{
        onClose()
    }
    const handleUpdateStatus1=()=>{
        handleUpdateStatus()
    }

  return (
<>
      <Dialog
      onClose={onClose}
      open={open}
      
      maxWidth={maxWidth}
      fullWidth

    >
     
      <DialogTitle
        variant="h4"
      >
    
{title}
       
      </DialogTitle>
      {showDivider && <Divider />}
      <DialogContent>
         <Typography variant='h4' textAlign="center"> Selected Item : {selectedId?.length}</Typography>
        <Typography variant='h4' textAlign="center"> {textBody}</Typography>
       </DialogContent>
      <DialogActions>
      <Button variant='outlined' size='small' color='error' onClick={handleClose}>Cancel</Button>
      <Button variant='contained' size='small' color='secondary' onClick={handleUpdateStatus1}>Accept</Button>
      
      </DialogActions>
    
    </Dialog>
   </>
  )
}
